import React from 'react';
import { Calendar, TrendingUp } from 'lucide-react';
import { experience as mockExperience } from '@/mock';
import '../styles/ExperienceSection.css';

const ExperienceSection = ({ experience: propsExperience, loading }) => {
  // Use props experience if available, otherwise use mock
  const experience = propsExperience && propsExperience.length > 0 ? propsExperience : mockExperience;

  if (loading) {
    return (
      <section className="experience-section" id="experience">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Experience</h2>
            <div className="title-underline"></div>
          </div>
          <div style={{ textAlign: 'center', color: '#a3a3a3', padding: '3rem' }}>
            Loading experience...
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="experience-section" id="experience">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Experience</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">6+ years building world-class mobile applications</p>
        </div>

        <div className="timeline">
          {experience.map((exp, index) => (
            <div key={exp.id} className="timeline-item" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="timeline-marker">
                <div className="marker-dot"></div>
                <div className="marker-line"></div>
              </div>

              <div className="timeline-content">
                <div className="timeline-card">
                  <div className="timeline-header">
                    <div>
                      <h3 className="position-title">{exp.position}</h3>
                      <div className="company-name">{exp.company}</div>
                    </div>
                    {exp.current && <span className="current-badge">Current</span>}
                  </div>

                  <div className="timeline-meta">
                    <span className="meta-item">
                      <Calendar size={16} />
                      {exp.duration}
                    </span>
                  </div>

                  <div className="achievements">
                    {exp.achievements.map((achievement, idx) => (
                      <div key={idx} className="achievement-item">
                        <TrendingUp size={16} className="achievement-icon" />
                        <span>{achievement}</span>
                      </div>
                    ))}
                  </div>

                  <div className="tech-tags">
                    {exp.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;